import React, { useEffect, useState } from 'react'
import { useYonghuListQuery } from '../../store/DianShangYeWuApi';   
import { Divider, Form, Select, Space } from 'antd';

function ReportOpSelect(props) {    
    const form = Form.useFormInstance();
    const [list,setList] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [open, setOpen] = useState(false);
    const {data,isSuccess,refetch} = useYonghuListQuery(
        {yh_qy_id:props.qy_id},{refetchOnMountOrArgChange:1}
    )
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                const newArr = data.Result.map((item, index) => {
                    const {yh_id,yh_name }=item;
                    return {value:yh_id,label:yh_name,key:yh_id || `yh_${index}`}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])

    const handleOpenChange = (openState) => {
        setOpen(openState);
        if(openState && !hasFetched && props.qy_id){
            refetch();
            setHasFetched(true);
        }
    }
    const handleQuickSelect = (value, label) => {
        // 设置 Form 的值
        if (form && props.name) {
            form.setFieldsValue({ [props.name]: value });
        }
        // 触发 onChange 回调
        props.onChange(value, label);
        // 关闭下拉菜单
        setOpen(false);
    };
    return (
         <Form.Item 
            label={props.label} 
            required  
            style={props.formStyle}
            name={props.name}
            normalize={(value) => value === '' ? undefined : value}
        >
            <Select
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label,)
                    }
                }}
                placeholder={props.placeholder}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
                open={open}
                onOpenChange={handleOpenChange}
                popupRender={menu => (
                    <>
                      {menu}
                      <Divider style={{ margin: '8px 0' }}/>
                      <div>常用：<Space>
                        {props.list && props.list.length > 0 && props.list.map((item, index) => (
                          <a key={item.value || `common_${index}`} onClick={() => handleQuickSelect(item.value, item.label)}>{item.label}</a>
                        ))}
                      </Space></div>                     
                    </>
                  )}
            />                        
        </Form.Item>
    )
}

export default ReportOpSelect

